import { useState } from 'react';
import Hero from './components/Hero';
import Products from './components/Products';
import About from './components/About';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Products />
      <About />
      <Contact />
    </div>
  );
}